import { FC } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { PatientDetailsWithId } from "../../types";

interface MenstruationDialogProps {
  patient: PatientDetailsWithId;
  handleClose: () => void;
  handleRemoveAndClose: () => void;
  open: boolean;
}

const RemovePatientDialog: FC<MenstruationDialogProps> = ({
  patient,
  handleClose,
  handleRemoveAndClose,
  open,
}) => {
  const fullName = `${patient.firstName} ${patient.lastName}`;
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Remove {fullName}</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography>
            This will remove {fullName} from your account, and remove you from
            their account. If you wish to re-add each other in the future, you
            will have to share your code with the patient again.
          </Typography>
          <Typography>
            <b>Are you sure you want to continue?</b>
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={handleRemoveAndClose}
          variant="contained"
          color="error"
          disableElevation
        >
          Remove patient
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemovePatientDialog;
